import React from 'react'
import { Typography } from '@mui/material'

import Box from 'components/Common/Box'
import GenericStatusChangePopper from 'components/Common/GenericStatusChangePopper'
import GoBackButton from 'components/Common/GoBackButton'
import Tag from 'components/Common/Tag'

import { ExtendedStatus, Status } from 'models/services/status'

import { colors } from 'styles/theme'

type DetailHeaderProps = {
  title: string
  backButtonText: string
  status?: ExtendedStatus | Status
  editable: boolean
  statusList?: ExtendedStatus[]
  loading?: boolean
  handleStatusChange?: (newStatus: ExtendedStatus) => void
}
export const DetailHeader = ({
  title,
  backButtonText,
  status,
  statusList,
  editable,
  loading = false,
  handleStatusChange,
}: DetailHeaderProps) => {
  return (
    <>
      <GoBackButton>{`< ${backButtonText}`}</GoBackButton>
      <Box display="flex" alignItems="center" paddingTop="0.5rem">
        <Typography variant="h3" color={colors.black} marginRight="1rem">
          {title}
        </Typography>
        {status && (
          <Tag
            backgroundColor={status.backgroundColor}
            color={status.textColor}
            text={status.name}
          />
        )}
        {editable && handleStatusChange && statusList && (
          <GenericStatusChangePopper
            status={status as ExtendedStatus}
            handleSaveStatus={handleStatusChange}
            statusList={statusList}
            loading={loading}
          />
        )}
      </Box>
    </>
  )
}
